import { gql } from '@apollo/client';

export const CREATE_DAILYCHIRP_MUTATION = gql`
  mutation CreateDailychirp($data: createDailychirpInput!) {
    createDailychirp(input: $data) {
      dailychirp {
        id
        date
        dailybirdData
      }
    }
  }
`;
